module.exports = __webpack_public_path__ + "img/KakaoTalk_logo.ce857aeb.svg";